module.exports = __webpack_public_path__ + "img/43_53.c262bff4.png";